module.exports = __webpack_public_path__ + "media/images/ajax-loader-4b01ca501fadf65135bfa7c8cc1cbc43.gif";